import { Link } from "react-router-dom";
import { Container, Typography } from "@mui/material";
function PageNotFound() {
  return (
    <>
      <Container sx={{ textAlign: "center", marginBottom: "50px" }}>
        <Typography
          sx={{
            fontSize: "70px",
            color: "#201A12",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          404 - Stranica nije pronađena
        </Typography>
        <br />
        <img src="/404.gif" alt="" style={{ width: "100%" }} />
        <br />
        <Link to="/" style={{ textDecoration: "none" }}>
          <Typography
            sx={{
              fontSize: "24px",
              display: "inline-block",
              marginTop: "20px",
              backgroundColor: "#201A12",
              color: "#FFFFFF",
              borderRadius: "999px",
              paddingTop: "14px",
              paddingBottom: "14px",
              paddingLeft: "36px",
              paddingRight: "36px",
              boxShadow: "0 18px 40px -24px rgba(23,19,14,.25)",
              "&:hover": { backgroundColor: "#C6912E", color: "#201A12" },
            }}
          >
            Vrati se na početnu
          </Typography>
        </Link>
      </Container>
    </>
  );
}

export default PageNotFound;
